<template>
  <div class="column full-height">
    <!-- Header -->
    <header
      class="row items-center justify-between q-px-2x-md"
      :style="{ height: '76px' }"
    >
      <span class="text-lg text-weight-medium">Templates</span>
      <PBtn color="primary" flat round @click="onClose">
        <CloseIcon class="icon" />
      </PBtn>
    </header>

    <q-separator />

    <!-- List View -->
    <div class="col overflow-hidden">
      <TemplateListView />
    </div>
  </div>
</template>

<script setup>
import CloseIcon from "assets/icons/close.svg";

const { toggleTemplatesDrawer } = useChatStore();

const props = defineProps({
  sendMessage: { type: Function, default: () => {} },
  sendingMessage: { type: Boolean, default: false },
});

provide("send-message-provider", props);

function onClose() {
  toggleTemplatesDrawer({ open: false });
}
</script>
